
/* injects from baggage-loader */

'use strict'
import { PlatesType } from '../../components/ui/types/plates';

import StageBaseController from '../stage-base.controller';

import { balloons } from './stage-one.const';
// import  { PlayerLevel } from '_appRoot/index.const'

export default class StageOneController extends StageBaseController{
    constructor($log, $rootScope, $state, $timeout, Dialog, Trophies, Session) {
        'ngInject';        
        super($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, 'main.stage-one');

        this.nextRoute = 'main.stage-two';
        this.defaultLevel = 1;
        
        this.state = {
            expireIn: 15, // 15 minutes
            region: 'nordeste',
            sequence: [
                PlatesType.entrance,
                PlatesType.principal,
                PlatesType.dessert,
                PlatesType.drink
            ]
        };

        this.balloons = {
            step: 0,
            steps: balloons
        };

        //testando

        this.auxaa = [];
    }

    $onInit(){

        this.Dialog.showRegionModal(this.state.region, () => {
            this.Dialog.showStageTutorial();
        }); 

        // Bind events
        this.$rootScope.$on('finish:countdown', this.onFinishCountdown.bind(this));
    }

    openSuccess(){        
        super.openSuccess();
    }

    isValid(){
        let isValid = true;
                
        this.model.items.forEach((item, index) => {
            if(item.value) {
                if (this.state.sequence[index] !== item.value.type ){
                    isValid = false;
                    this.auxaa[index] = undefined;
                }
                else{
                    this.auxaa[index] = item.value;
                }
            } else {
                isValid = false;
                this.auxaa[index] = undefined;
            }
        });

        this.$rootScope.$emit('correctItems', this.auxaa);

        return isValid;
    }    

    onSubmitOrder(){
        return this.isValid() ? this.openSuccess() : this.openFail();
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-one/stage-one.controller.js